import { useState } from "react";

// Income row: token icon + name + profit, with a share bar vs the top earner.
// Tokens without a usable icon are hidden entirely (owner 2026-08-10).
const TableDataVolumes = ({ item, maxUsd }) => {
  const [iconBroken, setIconBroken] = useState(false);

  if (!item?.image || iconBroken) return null;

  const usd = Number(item.SumUSDProfit) || 0;
  const share = maxUsd > 0 ? Math.max(2, Math.min(100, (usd / maxUsd) * 100)) : 0;

  return (
    <div
      key={item.id}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 12,
        padding: "10px 0",
        borderTop: "1px solid rgba(255,255,255,.05)",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 10, minWidth: 0, flex: 1 }}>
        <span className="coinB" style={{ width: 28, height: 28, boxShadow: "none", flex: "none" }}>
          <img src={item.image} alt="" onError={() => setIconBroken(true)} />
        </span>
        <div style={{ minWidth: 0, flex: 1 }}>
          <div
            className="cellStrong"
            style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", fontSize: 13 }}
          >
            {item.name}
          </div>
          <div
            style={{
              height: 4,
              borderRadius: 4,
              background: "rgba(255,255,255,.06)",
              marginTop: 5,
              overflow: "hidden",
              maxWidth: 150,
            }}
          >
            <div
              style={{
                width: `${share}%`,
                height: "100%",
                borderRadius: 4,
                background: item.color || "#3ad17e",
                opacity: 0.85,
              }}
            />
          </div>
        </div>
      </div>
      <div style={{ textAlign: "right", whiteSpace: "nowrap" }}>
        <div className="cellStrong" style={{ fontSize: 13.5 }}>
          ${usd.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
        </div>
        <div style={{ fontSize: 11, color: "#7c847e", fontWeight: 600 }}>
          {Number(item.SumProfit).toFixed(4)} {item.shortname || ""}
        </div>
      </div>
    </div>
  );
};

export default TableDataVolumes;
